<div class="container section retirement">

    <h1>ACEP Guide and Retired Application</h1>

    <form class="full-width" novalidate [formGroup]="retirementForm" *ngIf="!isUnauthorized; else unauth">
        <div *ngIf="!formSubmitted; else receipt">


            <div id='pageHeaderContent' [innerHTML]="headerText"></div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field>
                        <input matInput placeholder="Member’s Full Name and Title" readonly formControlName="formalName">
                        <!-- <mat-error *ngIf="retirementForm.get('firstName').errors?.required">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required
                </mat-error> -->
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <mat-form-field>
                        <input matInput placeholder="ACEP Member ID" readonly formControlName="acepId">
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <mat-form-field>
                        <!-- <input matInput placeholder="Date of Retirement" formControlName="retirementDate"> -->


                        <mat-label>Date of Retirement</mat-label>
                        <input formControlName="retirementDate" matInput [matDatepicker]="picker" [max]="maxRetirementDate">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>

                        <mat-error *ngIf="retirementForm.get('retirementDate').errors?.required">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required
                        </mat-error>

                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <mat-form-field>
                        <input matInput placeholder="Membership Expiration Date" readonly formControlName="expirationDate">
                    </mat-form-field>
                </div>
            </div>


            <app-address [address]="retirementForm.get('customerAddress')" [HIDEORG]="true" (ONSTATESELECT)="onAddress_StateChanged($event)" (ONCOUNTRYSELECT)="onAddress_CountryChanged($event)">
            </app-address>


            <div class="row FlowupLabels" [hidden]="isInternational">
                <div class="col-md-12">
                    <div class="validationwrap" [class.validation-error]="chapter.invalid && (chapter.dirty || chapter.touched || formSubmitted)">

                        <div class="fl_wrap">
                            <label class="fl_label">Chapter</label>
                            <select class="fl_input" FlowUpLabel formControlName="chapter">
                                <option value=""></option>
                                <option *ngFor="let obj of chapters" [value]="obj.code">{{obj.name}}</option>
                            </select>
                            <span class="validationhead">
                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required</span>
                        </div>
                        <span>Chapter options displayed are based on your recorded Home Address, Work Address, and Medical License(s) Address.</span>
                        <br><br>

                    </div>

                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="validationwrap" [class.validation-error]="attest.invalid && (attest.dirty || attest.touched || formSubmitted)">
                        <div class="checkboxWrap">
                            <mat-checkbox #a color="primary" formControlName="attest"><strong>By checking this box, I certify that the information contained on this application is true and that I meet the qualifications for retired status in the American College of Emergency Physicians.</strong></mat-checkbox>
                            <span class="validationhead">
                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Required</span>
                        </div>
                    </div>
                </div>
            </div>


            <div class="row actions">
                <div class="col-md-12">
                    <button mat-raised-button="mat-raised-button" class="btnSubmit" [disabled]="(retirementForm.invalid || retirementForm.pristine || (a.checked == false))" (click)="save()">Submit</button>
                </div>
            </div>

        </div>
        <ng-template #receipt>

            <div class="container">
                <div class="row">
                    <div class="col-md-12">



                        <h3>
                            <span class="circle-check">
                                <i class="fa fa-check-circle color-green fa-2x"></i>
                            </span>

                            <span>
                                Congratulations on your retirement! Your application has been successfully completed.
                            </span>
                        </h3>


                    </div>

                </div>

            </div>

        </ng-template>

    </form>

    <ng-template #unauth>
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h3><span>Sorry. This page can only be accessed by current ACEP Members.</span></h3>
                </div>
            </div>
        </div>
    </ng-template>

</div>